<eip-notes [userId]="userID"></eip-notes>
<span class="notes-close">Press Esc To Close</span>